import Api from "~/service/Api";

class TourJobRepository {
  fetch(query = {}) {
    return Api.get("/tour/jobs", query);
  }

  fetchOne(tourJobId) {
    return Api.get(`/tour/jobs/${tourJobId}`);
  }

  update(tourJobId, data) {
    return Api.post(`/tour/jobs/${tourJobId}`, data);
  }

  purchaseProduct(tourId, productId) {
    return Api.post(`/tour/jobs/${tourId}/purchase-product/${productId}`);
  }

  refundProduct(tourJobId, productId) {
    return Api.post(`/tour/jobs/${tourJobId}/refund-product/${productId}`);
  }
}

export default TourJobRepository;
